"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarItem = exports.ItemButton = exports.IconAndTextWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../../../../styles/palette");
var _helpers = require("../../../../../styles/helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ToolbarItem = exports.ToolbarItem = _styledComponents["default"].div.withConfig({
  displayName: "styles__ToolbarItem",
  componentId: "sc-tayudg-0"
})(["border-left:1px solid #ededed;height:100%;position:relative;&:first-child{border-left:none;}border-top:1px solid;border-top-color:", ";"], function (p) {
  return p.isActive ? '#ffffff' : '#ededed';
});
var IconAndTextWrapper = exports.IconAndTextWrapper = _styledComponents["default"].div.attrs({
  className: 'iconWrapper'
}).withConfig({
  displayName: "styles__IconAndTextWrapper",
  componentId: "sc-tayudg-1"
})(["position:relative;> label{display:block;line-height:1.125rem;padding:4px 0.5rem 0;max-width:100%;white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis;cursor:inherit;font-size:0.675rem;}.inline-hint-svg{width:15px;max-height:15px;height:auto;margin:0 auto;svg{height:100%;width:100%;display:block;fill:currentColor !important;", "}}"], _helpers.svgElementsFillCurrentColor);
var ItemButton = exports.ItemButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__ItemButton",
  componentId: "sc-tayudg-2"
})(["height:100%;width:100%;background:none;border:none;outline:none;padding:0;&:disabled{.iconWrapper{opacity:0.1;}}&:not(:disabled){color:", ";opacity:1;cursor:pointer;&:hover{background:rgba(0,0,0,0.05);.iconWrapper{opacity:1;}}}&.active{color:", ";opacity:1;.iconWrapper{opacity:1 !important;}&:hover{color:", ";background:none;}}"], function (p) {
  return p.isWarning ? _palette.commonPalette.orange : p.theme.hintColor;
}, function (p) {
  return p.isWarning ? _palette.commonPalette.orange : p.theme.mainDarker;
}, function (p) {
  return p.isWarning ? _palette.commonPalette.orange : p.theme.mainDarker;
});
//# sourceMappingURL=styles.js.map